import { render, staticRenderFns } from "./refundability.vue?vue&type=template&id=4821a06c&scoped=true"
import script from "./refundability.vue?vue&type=script&lang=js"
export * from "./refundability.vue?vue&type=script&lang=js"
import style0 from "./refundability.vue?vue&type=style&index=0&id=4821a06c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4821a06c",
  null
  
)

export default component.exports